import React from 'react';
import './Card.css';

interface CardProps {
  title: string;
  description: string;
  artwork?: React.ReactNode;
  cost?: number;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, description, artwork, cost, className }) => {
  return (
    <div className={`card ${className || ''}`}>
      <div className="card-title">{title}</div>
      {artwork && <div className="card-artwork">{artwork}</div>}
      <div className="card-description">{description}</div>
      {cost !== undefined && <div className="card-cost">{cost}</div>}
    </div>
  );
};

export default Card;
